import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import { NAV_LABEL_BY_KEY } from '@/config/navigation';
import { useMenuLabelStore } from '@/store/menuLabel.store';
import { menuLabelsQueryOptions } from '../api/menuLabels.api';

export function useMenuLabels(): { labelOf: (key: string) => string } {
  const labels = useMenuLabelStore((state) => state.labels);

  const labelOf = useCallback(
    (key: string) => labels[key] ?? NAV_LABEL_BY_KEY.get(key) ?? key,
    [labels],
  );

  return { labelOf };
}

export function useMenuLabelsSync(): void {
  const setLabels = useMenuLabelStore((state) => state.setLabels);
  const { data } = useQuery(menuLabelsQueryOptions());

  useEffect(() => {
    if (!data) return;
    setLabels(Object.fromEntries(data.map((row) => [row.menuKey, row.label])));
  }, [data, setLabels]);
}
